import React from "react";
import HomeHeader from "../../components/DashBoardComponents/Home/HomeHeader/index";
import HomeBalance from "../../components/DashBoardComponents/Home/HomeBalances/index";
import HomeProductSection from "../../components/DashBoardComponents/Home/HomeProduct/index";
import Chart from "../../components/DashBoardComponents/Home/HomeChart/index";
import HomeBigChat from "../../components/DashBoardComponents/Home/HomeBigChart/index";

import {
  BalanceContainer,
  OurProductContainer,
  ChatContainer,
} from "./home.styles";
import { HomeSpan } from "../../components/DashBoardComponents/Home/HomeBalances/homeBalance.styles";
import { useQuery } from "@apollo/client";
import { getUserBankDetails } from "../../graphql/queries/accounts";
import { styled } from "styled-components";

const Index = () => {
  const { data: queryData, refetch: refetchUserBankDetails } =
    useQuery(getUserBankDetails);

  const userBankDetails = queryData?.getUserBankDetails || {};
  const checkerArr = Object.keys(userBankDetails);
  return (
    <>
      <HomeHeader />
      <AccountContainer>
        {checkerArr.length === 0 ? (
          <span>Data Loading...</span>
        ) : (
          <>
            <HomeSpan>Balances</HomeSpan>
            <BalanceContainer>
              <HomeBalance />
            </BalanceContainer>
          </>
        )}
      </AccountContainer>
      <OurProductContainer>
        <HomeProductSection />
      </OurProductContainer>
      <ChatContainer>
        <Chart />
      </ChatContainer>
      <ChatContainer>
        <HomeBigChat />
      </ChatContainer>
    </>
  );
};

export default Index;

export const AccountContainer = styled.div`
  // width: 100%;
  /* height: 265px; */
  height: auto;
  flex-shrink: 0;
  border-radius: 10px;
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid var(--General-Stroke, #e8eaed);
  background: var(--General-White, #fff);
  box-shadow: 0px 4px 4px 0px rgba(234, 234, 234, 0.25);

  @media only screen and (max-width: 767px) {
    // width: 100%;
    display: flex;
    flex-direction: column;
  }
`;
